import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {articleSessionView_template} from "../components/templates/articleSessionView_template";

declare var ko: any;

export class article_session_view extends vnModule_knockoutJS {

    protected articleSessionViewTemplate : articleSessionView_template;
    protected moduleXHRHdl : XMLHttpRequestHandler;


    protected getModuleName(): string {
        return "article_session_view";
    }

    buildContent(): Array<Element>{
        this.articleSessionViewTemplate = new articleSessionView_template('list', this.viewModel, this);

        return [this.articleSessionViewTemplate.build()];
    }

    public fillPage(): void {

        let currentYear = new Date().getFullYear();
        this.articleSessionViewTemplate.setSuccessSelectedYearBrand(currentYear);
        this.articleSessionViewTemplate.setFailureSelectedYearBrand(currentYear);
        this.populateBrandSessionTarget(currentYear);
    }

    public populateBrandSessionTarget(currentYear) {

        if( this.moduleXHRHdl ){
            this.moduleXHRHdl.cancelAndReset();
        }

        this.loadingIn(this.articleSessionViewTemplate.builtTemplate.children.namedItem('session-target-list-results'));

        let usrReq_url: string = '/api/session-target/get/' + currentYear;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({mode: 'view'})]);

        this.moduleXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.moduleXHRHdl.onReadyStateFunction = this.onListFormDataRequestReturn;
        this.moduleXHRHdl.execute();
    }

    public onListFormDataRequestReturn(req, obj) {
        return function() {
            obj.manageResponse(req, obj, function(){
                let response = JSON.parse(req.request.response);

                obj.updateList(response.sessionTargetList);
                obj.updateYearList(response.sessionTargetYears, response.year, response.type || 'all');
                obj.updateFallback(response.fallback);
                obj.updateContentTypes(response.contentTypes);
                obj.loadingOut(obj.articleSessionViewTemplate.builtTemplate.children.namedItem('session-target-list-results'));
            });
        }
    }

    public updateList(sessionTargets) {
        this.articleSessionViewTemplate.setListingSessionTargets(sessionTargets);
    }


    public updateYearList(years, currentYear, type) {

        if (type == 'all' || type == 'success') {
            this.articleSessionViewTemplate.setYearsOnSuccessConfig(years, currentYear);
        }
        if (type == 'all' || type == 'failure') {
            this.articleSessionViewTemplate.setYearsOnFailureConfig(years, currentYear);
        }
    }

    public updateFallback(fallback: number): void {

        this.articleSessionViewTemplate.setFallback(fallback);
    }

    public updateContentTypes(contentTypes) {
        this.articleSessionViewTemplate.setContentTypes(contentTypes);
    }

    /**
     * Dropdown event change
     * @param data
     */
    public filterDropdownOnChange(data) {

        let yearSelector = this.articleSessionViewTemplate.getYearSelector();
        this.updateSessionBrandDisplay();
        this.articleSessionViewTemplate.setSuccessSelectedYearBrand(yearSelector);
    }

    protected updateSessionBrandDisplay() {
        if( this.moduleXHRHdl ){
            this.moduleXHRHdl.cancelAndReset();
        }

        let selectedYear: string = this.articleSessionViewTemplate.getYearSelector();
        let selectedType: string = this.articleSessionViewTemplate.getSelectedType();

        this.loadingIn(this.articleSessionViewTemplate.builtTemplate.children.namedItem('session-target-list-results'));

        // Make the year Dynamic
        let usrReq_url: string = '/api/session-target/get/' + selectedYear;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({type: selectedType, mode: 'view'})]);

        this.moduleXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.moduleXHRHdl.onReadyStateFunction = this.onListFormDataRequestReturn;
        this.moduleXHRHdl.execute();
    }

}


// WEBPACK FOOTER //
// ./js/modules/article_session_view.ts